import React from "react";
import { StepConfig } from "../Leadform/steps";
import { UTMParams } from "../utils";

export type LeadFormContextType = {
  steps: Array<StepConfig>;
  step: number;
  setStep: (step: number) => void;
  responses: Record<string, string | number | readonly string[]>;
  setResponses: React.Dispatch<React.SetStateAction<Record<string, unknown>>>;
  utms: UTMParams;
  setUTMs: React.Dispatch<React.SetStateAction<UTMParams>>;
  userPath: string;
  setUserPath: React.Dispatch<React.SetStateAction<string>>;
  sessionKey: string;
  setSessionKey: React.Dispatch<React.SetStateAction<string>>;
  loading: boolean;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  updateValue: (name: string, value: string | { [key: string]: any }) => void;
};

export const LeadFormContext = React.createContext<LeadFormContextType | null>(
  null,
);

export function useLeadForm() {
  const ctx = React.useContext(LeadFormContext);
  if (!ctx) throw new Error("useLeadForm must be used within LeadForm");
  return ctx;
}
